import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import * as React from 'react';
import cn from 'classnames';
import { Text } from '../../text';
export var Heading = function Heading(props) {
  var className = props.className,
    textProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(Text, _extends({
    className: cn('heading', className)
  }, textProps));
};
Heading.defaultProps = {
  as: 'div',
  size: 4
};